var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title" }, [_vm._v("尺寸信息")]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "20px" },
          attrs: { data: _vm.pdmClothDetailVo.dataArray, border: "" },
        },
        _vm._l(_vm.pdmClothDetailVo.tableHead, function (item) {
          return _c(
            "el-table-column",
            {
              key: item.filedCode,
              attrs: { prop: item.filedCode, label: item.filedName },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          item.filedCode === "tolerance"
                            ? _c("span", [_vm._v("±")])
                            : _vm._e(),
                          _vm._v(_vm._s(scope.row[item.filedCode])),
                        ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            [
              _c("template", { slot: "header" }, [
                _c("span", { staticClass: "center" }, [
                  _vm._v(_vm._s(item.filedName)),
                ]),
              ]),
            ],
            2
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [_vm._v("纸样/唛架图")]),
      _vm._v(" "),
      _c("div", { staticClass: "paper-pattern-image" }, [
        _c(
          "div",
          { staticClass: "type" },
          [
            _c("div", [_vm._v("大货纸样")]),
            _vm._v(" "),
            _vm._l(
              _vm.pdmClothDetailVo.commonAttachmentVos,
              function (item, index) {
                return _c("div", { key: index }, [
                  item.attachmentType === "2"
                    ? _c(
                        "div",
                        { staticClass: "card-list" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "images",
                              on: {
                                click: function ($event) {
                                  return _vm.handleDownload(item.id)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "imageName" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.fileName) +
                                    "\n              "
                                ),
                                _c("i", {
                                  staticClass: "iconfont iconmain-download",
                                }),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isAssetTypeAnImage(item.fileType)
                            ? _c("el-image", {
                                attrs: {
                                  src: _vm._f("picFilter")(item.url, {
                                    size: "large",
                                  }),
                                  "preview-src-list": [item.url],
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              }
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }